var map = {
	"./directives/templates/addFriends.html": 98,
	"./directives/templates/chatAbuseReport.html": 99,
	"./directives/templates/chatAvatarHeadshot.html": 100,
	"./directives/templates/chatBar.html": 101,
	"./directives/templates/chatBase.html": 102,
	"./directives/templates/chatDialog.html": 103,
	"./directives/templates/chatGameIcon.html": 104,
	"./directives/templates/chatGroupDialog.html": 105,
	"./directives/templates/chatPlaceholder.html": 106,
	"./directives/templates/confirmNegativeAction.html": 107,
	"./directives/templates/conversationTitle.html": 108,
	"./directives/templates/conversationTitleEditor.html": 109,
	"./directives/templates/createChatGroup.html": 110,
	"./directives/templates/details.html": 111,
	"./directives/templates/dialogHeader.html": 112,
	"./directives/templates/dialogMinimize.html": 113,
	"./directives/templates/displayMessage.html": 114,
	"./directives/templates/gamesList.html": 115,
	"./directives/templates/linkCard.html": 116,
	"./directives/templates/selectFriends.html": 117,
	"./directives/templates/systemMessage.html": 118,
	"./directives/templates/userConversationInfo.html": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;